<template>
    <div>
        <main-slider></main-slider>
        <section-project></section-project>
    </div>
</template>
<script>
import MainSlider from '../components/MainSlider';
import SectionProject from '../components/SectionProject';


export default {
    components: {
        MainSlider,
        SectionProject,
    },
    props: {},
    data() {
        return {};
    },
    methods: {},
    created() { },
};
</script>